import React from 'react';
import { WrappedComponentProps, injectIntl } from 'react-intl';

import { Button, TypographyStyle, TypographyWeight, ThemeStyle, ButtonPlain } from '../../../panda';

import { Typography } from '../../Typography';
import { Modal } from '../';
import { BtnContainer, ModalContainer } from './styled';

interface IProps extends WrappedComponentProps {
  onClose: () => void;
  onConfirm?: () => void;
  closeTextId?: string;
  confirmTextId?: string;
  titleTextId: string;
  descriptionTextId: string;
  isDelete?: boolean;
}

const ErrorModal: React.FC<IProps> = ({
  onClose,
  onConfirm,
  confirmTextId = 'global.button.confirm',
  closeTextId = 'global.button.close',
  titleTextId,
  descriptionTextId,
  isDelete = false,
  intl: { formatMessage },
}) => (
  <Modal onClose={onClose} style={{ height: '140px' }}>
    <ModalContainer>
      <Typography type={TypographyStyle.H4} weight={TypographyWeight.Medium}>
        {formatMessage({ id: titleTextId })}
      </Typography>
      <Typography type={TypographyStyle.P2} style={{ whiteSpace: 'initial' }}>
        {formatMessage({ id: descriptionTextId })}
      </Typography>
      <BtnContainer>
        <Button
          isSmall
          isRounded={false}
          onClick={onClose}
          css={onConfirm ? 'margin-right: 20px' : ''}
        >
          {formatMessage({ id: closeTextId })}
        </Button>
        {onConfirm && (
          <ButtonPlain
            onClick={onConfirm}
            theme={isDelete ? ThemeStyle.red : ThemeStyle.black}
            isSmall
          >
            {formatMessage({ id: confirmTextId })}
          </ButtonPlain>
        )}
      </BtnContainer>
    </ModalContainer>
  </Modal>
);

export default injectIntl(ErrorModal);
